// Velo code for masterPage.js

import wixUsers from 'wix-users';
import wixData from 'wix-data';
import { session } from 'wix-storage'; // Import session storage

// --- CONFIGURATION ---
// Replace with the ID of your CTID Registrations collection in Wix Data
const ctidCollectionId = "CTID_Registrations";
// --------------------

// Set up a listener for when a user logs in ANYTIME, ANYWHERE on the site
wixUsers.onLogin(async (user) => {
    console.log("[masterPage.js - onLogin] User has just logged in. Member ID:", user.id);
    // Retrieve CTID from session storage (set by the /trading page's onReady)
    let ctidToSave = session.getItem("pendingCTID");

    if (ctidToSave) {
        console.log("[masterPage.js - onLogin] Found pending CTID in session:", ctidToSave);
        await saveCtidToDatabase_Global(ctidToSave, user); // Call the save function
    } else {
        console.log("[masterPage.js - onLogin] No pending CTID found in session storage after login.");
    }
});

// Reusable function to save the CTID (slightly modified for masterPage context)
async function saveCtidToDatabase_Global(ctidValue, loggedInUser) {
    try {
        const userId = loggedInUser.id;
        if (!userId) {
            console.error("[masterPage.js] Cannot save CTID: User ID is missing after login.");
            return;
        }

        // Check if this member already has a CTID registered
        const existing = await wixData.query(ctidCollectionId)
            .eq("memberId", userId)
            .limit(1)
            .find();

        if (existing.totalCount === 0) {
            // Not registered yet, insert new record
            // Get email directly from the user object passed to onLogin
            const userEmail = await loggedInUser.getEmail();
            const itemToInsert = {
                title: userEmail || userId, // Use email as title, fallback to ID
                memberId: userId,
                ctid: ctidValue,
                submittedOn: new Date(),
                email: userEmail
            };
            console.log("[masterPage.js] Inserting new CTID record:", itemToInsert);
            await wixData.insert(ctidCollectionId, itemToInsert);
            console.log("[masterPage.js] CTID saved successfully.");
            // Clear from session only after successful save
            session.removeItem("pendingCTID");
        } else {
            // Already registered
            console.log("[masterPage.js] User already has a CTID registered:", existing.items[0].ctid);
            // Optionally update logic here if needed
            session.removeItem("pendingCTID"); // Clear session even if they exist
        }

    } catch (error) {
        console.error("[masterPage.js] Error saving CTID to Wix Data:", error);
    }
}